module.exports = __webpack_public_path__ + "img/red-3-oval-striped.1928bf6e.svg";